import { chartPointToPixel } from "../coordinateUtils";
import { createDrawingObject, replaceLastPoint } from "../shared";
export function calculateInfoLineGeometry(drawing, scales) {
    const [p0, p1] = drawing.points;
    if (!p0 || !p1)
        return null;
    const start = chartPointToPixel(p0, scales);
    const end = chartPointToPixel(p1, scales);
    const priceChange = p1.y - p0.y;
    const priceChangePercent = p0.y !== 0 ? ((p1.y - p0.y) / p0.y) * 100 : 0;
    const barsCount = Math.abs((p1.xIndexFloat ?? 0) - (p0.xIndexFloat ?? 0)) || 0;
    // Risk/Reward calculation (assuming p0 is entry, p1 is target)
    // Stop would be at the opposite side of entry from target
    const entryPrice = p0.y;
    const targetPrice = p1.y;
    const stopPrice = entryPrice - (targetPrice - entryPrice); // Symmetric risk
    const riskRewardRatio = stopPrice !== entryPrice ? Math.abs((targetPrice - entryPrice) / (entryPrice - stopPrice)) : null;
    return {
        start,
        end,
        priceChange,
        priceChangePercent,
        barsCount,
        riskRewardRatio,
        entryPrice,
        stopPrice,
        targetPrice,
    };
}
const InfoLine = {
    name: "infoLine",
    createDraft: (startPoint) => createDrawingObject("infoLine", [startPoint, startPoint]),
    updateDraft: (draft, nextPoint) => replaceLastPoint(draft, nextPoint),
    render: () => undefined,
};
export default InfoLine;
